import type { PrebidStore } from "@/ts/types";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
export const initialState = {
    testgroup: "",
};
export const prebidStore = createStore<PrebidStore>()(devtools(subscribeWithSelector(immer((set, get) => ({
    ...initialState,
    actions: {
        setOzoneTestGroup: (testgroup) => set((state) => {
            state.testgroup = testgroup;
        }),
    },
    selectors: {
        getOzoneTestGroup: () => ({ testgroup: get().testgroup }),
    },
}))), {
    name: "Hydra-PrebidStore",
}));
